<template>
  <div :class="['card', { 'business-reply': messageOwner === 2 }, { 'private-reply': messageType === 'Private' }]">
    <div class="card-content">
      <article class="media">
        <figure class="media-left is-hidden-mobile">
          <avatar v-if="!showLogo" :backgroundColor="avatarBackColour" color="#ffffff" :username="avatarString"></avatar>
          <img v-if="showLogo" class="business-logo" :src="businessLogo" alt="Business reply" />
        </figure>
        <div class="media-content">
          <h4 v-html="replyHeading"></h4>
          <p class="date-time" v-html="formattedDateAndTime"></p>
          <p v-html="messageBody"></p>
        </div>
        <div v-if="showPrivateReplyBadge" class="media-right"><span class="tag">Private Reply</span></div>
      </article>
    </div>
  </div>
</template>
<script>
  import Avatar from 'vue-avatar'
  import moment from 'moment'
  import misc from '../mixins/misc.js'

  export default {
    name: 'ReviewMessage',
    mixins: [misc],
    components: {
      Avatar
    },
    props: {
      messageFrom: {
        type: String
      },
      messageOwner: {
        type: Number
      },
      messageBody: {
        type: String
      },
      messageType: {
        type: String
      },
      businessLogo: {
        type: String,
        default: ''
      },
      createdAt: {
        type: String
      },
      showPrivateReplyBadge: {
        type: Boolean,
        default: false
      },
      isLinkedToUser: {
        type: Boolean
      }
    },
    computed: {
      avatarString () {
        if (this.messageOwner === 2 && this.businessLogo !== null && this.businessLogo.length > 0) {
          return `${this.businessLogo}`
        }
        return `${this.messageFrom}`
      },
      avatarBackColour () {
        if (this.messageOwner === 1) {
          return '#88397F'
        }
        return '#394B88'
      },
      showLogo () {
        return this.messageOwner === 2 && this.businessLogo !== null && this.businessLogo.length > 0
      },
      replyHeading () {
        if (this.messageOwner === 1) {
          return `${this.messageFrom}:`
        }
        return `${this.messageFrom}'s reply:`
      },
      formattedDateAndTime () {
        return moment(this.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY, HH:mm')
      }
    }
  }
</script>
<style scoped>
  .card {
    border: 1px solid #C9C9C9;
    box-shadow: none;
    color: #58595B;
    margin-top: 2rem;
  }

  .card.business-reply {
    border: none;
    background-color: #F5F5F5;
  }

  .card.business-reply.private-reply, .card.private-reply {
    border: none;
    background-color: #ccc;
  }

  .media-content {
    width: 90%;
  }

  .media-content > h1 {
    font-size: 0.8rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .media-content > h2 {
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    margin-right: 2rem;
    font-size: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 90%;
  }

  .media-content > p {
    font-size: 0.9rem;
    line-height: 1.4rem;
    text-align: left;
    margin-right: 2rem;
    padding-right: 1rem;
  }

  .business-logo {
    width: 50px;
    border-radius: 50%;
    border: 1px solid #F5F5F5;
  }

  h4 {
    font-weight: bold;
  }

  .date-time {
    color: #8A8C91;
    font-size: 0.7rem!important;
    margin: 0.3rem 0 1.2rem 0;
  }

  @media screen and (max-width: 767px) {
    .media-content > h2 {
      overflow: visible;
      white-space: normal;
      width: 100%;
    }

    .media-content > p {
      margin-right: 0;
      padding-right: 0;
    }

    .card {
      border: none;
      border-top: 1px solid #C9C9C9;
    }

    .card.bottom-margin ~ .card {
      margin-bottom: 0;
      border: none;
      border-bottom: 1px solid #C9C9C9;
      margin-top: 0;
    }

    .is-review-details .card {
      margin-bottom: 0;
      margin-top: 0;
    }

    .is-review-details .media-content {
      overflow: unset;
      margin-right: 0!important;
      padding-right: 0!important;
      width: 100%!important;
    }

    .is-review-details .card .media-content, .is-review-details .card .media-content > .is-detail-card, .is-review-details .card .media-content > h1, .is-review-details .card .media-content > h2 {
      width: 100%;
    }

    .is-review-details .card .media-content > .full-content {
      margin-right: 0;
      padding-right: 0;
    }

    .private-reply {
      border-bottom: 1px solid #58595B!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ReviewMessage.vue